import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { Link } from 'react-router-dom'

import EntryBox from './EntryBox'

class LandingPageGallery extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      entries: [],
      meta: [],
    }

    this.onFetchEntriesSuccess = this.onFetchEntriesSuccess.bind(this)
    this.onFetchEntriesFailure = this.onFetchEntriesFailure.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    this.fetchEntries()
  }

  componentWillUnmount() {
    this.cancelSource.cancel()
  }

  fetchEntries() {
    axios.get(`/api/internal/${this.props.competitionSlug}/competition-submissions?limit=8`, { cancelToken: this.cancelSource.token })
      .then(this.onFetchEntriesSuccess)
      .catch(this.onFetchEntriesFailure)
  }

  onFetchEntriesSuccess(response) {
    this.setState({
      meta: response.data.meta,
      entries: response.data.data,
    })
  }

  onFetchEntriesFailure() {
  }

  render() {
    return (
      <span>
        {
          this.state.entries.length > 0
          && (
          <section className="content-section section--gallery infinite-gallery">
            <div className="container-fixed">
              <h2 className="content-section__title">Recent entries</h2>
              <p className="content-section__subtitle">
                Get the most likes and win the Public Award! Take a look at the latest entries:
              </p>

              <div className="row infinite-gallery__list">
                {this.state.entries.map((entry, index) => {
                  return (
                    <EntryBox
                      competitionSlug={this.props.competitionSlug}
                      path={`${this.props.competitionSlug}/gallery`}
                      id={entry.id}
                      entryName={entry.attributes.name}
                      entrySlug={entry.attributes.slug}
                      authorName={entry.attributes.authorName}
                      imageUrl={entry.attributes.primaryImage.url}
                      key={index}
                    />
                  )
                })}
              </div>

              <div className="u-text-center">
                <Link to={`/${this.props.competitionSlug}/gallery`} className="btn btn-primary">View all</Link>
              </div>
            </div>
          </section>
          )
        }
      </span>
    )
  }
}

LandingPageGallery.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
}

export default LandingPageGallery
